export type SavingsType = {
  name: string;
  value: string;
};

export type SavingsTypesDocument = {
  data: SavingsType[];
  updatedAt: string | null;
  updatedById?: string;
  updatedByName?: string;
};

// The savings type new Optimize data starts with; the API refuses to remove it.
export const DEFAULT_SAVINGS_TYPE = 'Potential Savings';
